<div #content class="pointer-events-none">
  <ng-container *ngTemplateOutlet="template" />
</div>
